// Mode « tablette du magasin » : appareil partagé par toute l'équipe.
// Activé une fois sur l'appareil (page /app/tablette), mémorisé dans ce navigateur seulement.
// Effets : déconnexion automatique après 2 min sans toucher l'écran, prénom jamais pré-rempli.
const KEY = 'kioskMode'

export const KIOSK_IDLE_MS = 2 * 60 * 1000   // 2 minutes sans toucher l'écran
export const KIOSK_WARN_MS = 20 * 1000       // compte à rebours affiché les 20 dernières secondes

export function isKiosk(): boolean {
  try { return localStorage.getItem(KEY) === '1' } catch { return false }
}

export function setKiosk(on: boolean) {
  try {
    if (on) localStorage.setItem(KEY, '1')
    else localStorage.removeItem(KEY)
  } catch { /* stockage indisponible : le mode reste inactif */ }
}
